import { render, staticRenderFns } from "./vModelList.vue?vue&type=template&id=33d83c3a&scoped=true&"
import script from "./vModelList.vue?vue&type=script&lang=js&"
export * from "./vModelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d83c3a",
  null
  
)

export default component.exports